import { render, staticRenderFns } from "./FoodSharePointResultEntry.vue?vue&type=template&id=0fd1394b&scoped=true"
import script from "./FoodSharePointResultEntry.vue?vue&type=script&lang=js"
export * from "./FoodSharePointResultEntry.vue?vue&type=script&lang=js"
import style0 from "./FoodSharePointResultEntry.vue?vue&type=style&index=0&id=0fd1394b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd1394b",
  null
  
)

export default component.exports